import { useTranslation } from 'react-i18next'
import { isGoogleMapsEmbedUrl } from '../utils/embedUrl'
import styles from './GoogleLocation.module.scss'

interface LocationPreviewProps {
  embedUrl: string
}

/**
 * The connected place on Google's free Maps Embed, so the owner can see it
 * is theirs. Nothing from Google is loaded but this frame.
 */
function LocationPreview({ embedUrl }: LocationPreviewProps) {
  const { t } = useTranslation()
  if (!isGoogleMapsEmbedUrl(embedUrl)) return null

  return (
    <div className={styles.preview}>
      <iframe
        className={styles.previewFrame}
        src={embedUrl}
        title={t('GOOGLE_LOCATION.PREVIEW_TITLE')}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
      />
    </div>
  )
}

export default LocationPreview
